import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_pizzaria-express-3/artifacts/dx0kloue_emergent.png";
export const STORE_NAME = "Paulista's Lanches & Pizzas";
